import { getRequestTokenPair } from "api/auth";
import { JOURNALS_ENDPOINT } from "api/endpoints";
import { createAuthorizedFetch } from "api/fetch";
import classNames from "classnames";
import Button from "components/Button";
import { JournalCard } from "components/journals/JournalCard";
import { Navbar } from "components/Navbar";
import { SearchBoxV2 } from "components/Search";
import { useUser } from "hooks/user";
import { Journal } from "models/journal";
import { GetServerSidePropsContext } from "next";
import Head from "next/head";
import React, { PropsWithChildren, useState } from 'react'


export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  // const tokens = getRequestTokenPair(ctx.req)
  // const fetchFn = createAuthorizedFetch(tokens?.accessToken)

  const journals = await (await fetch(JOURNALS_ENDPOINT)).json() as Journal[]

  return {
    props: {
      journals,
    },
  }
}

export default function JournalsPage({ journals }: { journals: Journal[] }) {
  const [currentUser] = useUser()
  const [searchQuery, setSearchQuery] = useState('')
  return <div>
    <Head><title>Журналы платформы</title></Head>
    <Navbar user={currentUser} static />
    <div className="mt-1 flex flex-col gap-2 max-w-[80%] mx-auto px-4">
      <SearchBoxV2 query={searchQuery} setQuery={setSearchQuery} placeholder="Найти журнал" className="w-full" explicit />
      <div className="flex flex-col gap-1 pb-5">
        {journals.filter(v => searchQuery === '' 
          || v.name.includes(searchQuery)
          || v.name_international.includes(searchQuery)
        ).sort((a, b) => (b.priority ?? 0) - (a.priority ?? 0)).map(v => <JournalCard journal={v} key={v.id} full border />)}
      </div>
    </div>
  </div>
}
